import { VideoControllerFactory } from "plugins/Video/controllers/VideoControllerFactory"
import { Builder } from "."
import { SocketSlice } from "./types"
import { createAction } from "@reduxjs/toolkit"

export const subToFlightEvents = createAction<string>("live-video/subToFlightEvents")
export const unsubToFlightEvents = createAction<string>("live-video/unsubToFlightEvents")

export default {
    handlers: (builder: Builder) =>
        builder
            .addCase(subToFlightEvents, (_, action, socket) => {
                socket.emit("subscribeToDroneEvents", action.payload)
            })
            .addCase(unsubToFlightEvents, (_, action, socket) => {
                socket.emit("unsubscribeToDroneEvents", action.payload)
            }),
    events: {
        livedroneevent: () => (payload: string) => {
            const { data, flightId } = JSON.parse(payload)
            VideoControllerFactory.getOrCreateControllerForFlight({ flightId }).then(
                (controller) => {
                    if (controller) {
                        controller.pushData(data)
                    }
                }
            )
        },
    },
} as SocketSlice
